import projection from '../generated/pwh201f1.json';
import { AcceptanceManifest } from '../types';
export const pwh201f1AcceptanceManifest = projection as AcceptanceManifest;
